import { useReduxState } from 'hooks';
import { AchievementTemplate } from 'components/achievements';

const AchievementSummary = () => {
  const {
    messages,
    pageState: { achievement }
  } = useReduxState();

  return (
    <>
      {achievement?.type === 'conversation' ||
      achievement?.type === 'group-conversation' ? (
        <AchievementTemplate
          addItemText={messages.commonAddQuestion}
          addItemSuccessMessage={messages.commonAddQuestionSuccess}
          deleteAllSuccessMessage={
            messages.achievementUsersTemplateDeleteAllQuestionsSuccess
          }
          deleteAllText={
            messages.achievementUsersTemplateDeleteAllQuestionsConfirm
          }
          deleteAllTitle={messages.achievementUsersTemplateDeleteAllQuestions}
          deleteItemSuccessMessage={
            messages.achievementUsersTemplateDeleteQuestionSuccess
          }
          deleteItemText={
            messages.achievementUsersTemplateDeleteQuestionConfirm
          }
          deleteItemTitle={messages.achievementUsersTemplateDeleteQuestion}
          editItemTitle={messages.commonEditQuestion}
          editItemSuccessMessage={messages.commonEditQuestionSuccess}
          itemAnswerableByUserLabel={
            messages.achievementItemsQuestionAnswerableByUser
          }
          itemLabel={messages.commonQuestion}
          itemMarkableByUserLabel={
            messages.achievementItemsQuestionMarkableByUser
          }
          noItemsTitle={messages.commonNoQuestions}
          title={messages.commonQuestions}
        />
      ) : achievement?.type === 'tasklist' ? (
        <AchievementTemplate
          addItemText={messages.commonAddTask}
          addItemSuccessMessage={messages.commonAddTaskSuccess}
          deleteAllSuccessMessage={
            messages.achievementUsersTemplateDeleteAllTasksSuccess
          }
          deleteAllText={messages.achievementUsersTemplateDeleteAllTasksConfirm}
          deleteAllTitle={messages.achievementUsersTemplateDeleteAllTasks}
          deleteItemSuccessMessage={
            messages.achievementUsersTemplateDeleteTaskSuccess
          }
          deleteItemText={messages.achievementUsersTemplateDeleteTaskConfirm}
          deleteItemTitle={messages.achievementUsersTemplateDeleteTask}
          editItemTitle={messages.commonEditTask}
          editItemSuccessMessage={messages.commonEditTaskSuccess}
          itemAnswerableByUserLabel="" // not supported for tasklists
          itemLabel={messages.commonTask}
          itemMarkableByUserLabel={messages.achievementItemsTaskMarkableByUser}
          noItemsTitle={messages.tasksNoTasks}
          title={messages.tasks}
        />
      ) : null}
    </>
  );
};

export default AchievementSummary;
